import React from "react";
import { IntlProvider } from "react-intl";

import enMessages from "../i18n/en.json";

export default function I18nProvider({ children }) {
  return (
    <IntlProvider locale="en" messages={enMessages}>
      {children}
    </IntlProvider>
  );
}
